<template>
  <div class="list">
    <el-col class="marginBtm">
      <el-card class="searchCard" shadow="never">
        <el-form :inline="true" :model="search_form">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="comeTime"
              type="datetimerange"
              align="right"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="微信渠道号">
            <el-input
              style="width:160px;"
              v-model="search_form.FChannelId"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="search" label="查询"></auth-button>
            <auth-button opt="upload" @click.native="qrCodeVisible=true" v-if="agentLevel === 1" label="上传二维码"></auth-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-dialog title="上传渠道商拓展二维码" v-if="qrCodeVisible" :visible.sync="qrCodeVisible" width="600px" @close="closeModal">
      <el-row>
        <el-form label-width="100px" ref="myForm" :rules="formRules" :model="qrCodeForm">
          <el-form-item label="微信渠道号" prop="channelNo">
            <el-input v-model="qrCodeForm.channelNo" placeholder="请输入微信渠道号"></el-input>
          </el-form-item>
          <el-form-item label="拓展二维码" prop="imgUrl">
            <div>请上传正确的渠道商拓展二维码，否则将影响商户微信认证</div>
            <upload-img-ele
              label=""
              v-model="qrCodeForm.imgUrl"
              :value="qrCodeForm.imgUrl"
              valueName="qrCodeForm.imgUrl"
              @upload="uploadSuccess"
              desc=""></upload-img-ele>
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer">
        <el-button type="primary" size="small" @click="addQrCode" :loading="loading">确认</el-button>
        <el-button size="small" @click="closeModal">取消</el-button>
      </div>
    </el-dialog>
    <el-card class="tableCard" shadow="never">
      <el-table stripe style="width: 100%;" v-loading="loading" :data="list" :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fUpdateTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAgentId"
          label="代理商编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="agentName"
          label="代理商名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fChannelNo"
          label="微信渠道号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fChannelName"
          label="渠道号主体"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center">
          <template slot-scope="scope">
            <a :href="host + '/wechat-certificate/down-load-pic?FQrcode=' + scope.row.fChannelQrcodeUrl" style="color:#409EFF" download="渠道商拓展二维码.png">下载渠道商拓展二维码</a>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import uploadImgEle from '@/components/upload/uploadImgEle'
import { agentChannelList, uploadChannelQrCode } from '@/api/channel'
import api from '@/api/index'
export default {
  name: 'ExtendQrCode',
  components: {
    uploadImgEle
  },
  computed: {
    agentLevel () {
      const userInfo = this.$store.getters.userInfo
      return userInfo.userEntity.fAgentLevel
    }
  },
  data () {
    return {
      host: api.host,
      formRules: {
        channelNo: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('账号不能空'))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        imgUrl: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('上传二维码不能为空'))
              }
            },
            required: true,
            trigger: 'blur'
          }
        ]
      },
      comeTime: [],
      search_form: {
        FStartTime: '',
        FEndTime: '',
        FMerchantId: '', // 商户编号
        FAuthorizeState: '', // 授权状态
        FChannelId: '', // 微信渠道号
        FWxSubMchId: '', // 微信商户号
        pageNo: 1,
        pageSize: 10,
        count: 0
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setHours(0)
            start.setMinutes(0)
            start.setSeconds(0)
            end.setHours(23)
            end.setMinutes(59)
            end.setSeconds(59)
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      loading: false,
      list: [],
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      qrCodeVisible: false,
      qrCodeForm: {
        channelNo: null,
        imgUrl: '',
        qrCodeUrl: ''
      }
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
  },
  methods: {
    resetForm () {
      this.qrCodeForm = {
        channelNo: null,
        qrCodeUrl: ''
      }
    },
    closeModal () {
      this.qrCodeVisible = false
      this.resetForm()
    },

    /**
       * @description 图片上传成功的回调
       */
    uploadSuccess (data) {
      // console.log(data)
      this.qrCodeForm.qrCodeUrl = data.path
      this.qrCodeForm.imgUrl = data.showPath
    },
    /**
       * @description 初始日期选择
       */
    setDefaultDate () {
      let end = new Date()
      let start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      start = start.getFullYear() + '-' + (((start.getMonth() + 1) < 10) ? ('0' + (start.getMonth() + 1)) : (start.getMonth() + 1)) + '-' + ((start.getDate() < 10) ? ('0' + start.getDate()) : (start.getDate())) + ' 00:00:00'
      end = end.getFullYear() + '-' + (((end.getMonth() + 1) < 10) ? ('0' + (end.getMonth() + 1)) : (end.getMonth() + 1)) + '-' + ((end.getDate() < 10) ? ('0' + end.getDate()) : (end.getDate())) + ' 23:59:59'
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    /**
       * @description 日期选择器change事件
       */
    dateChange (value) {
      if (value !== null) {
        this.search_form.FStartTime = value[0]
        this.search_form.FEndTime = value[1]
      } else {
        this.search_form.FStartTime = ''
        this.search_form.FEndTime = ''
      }
    },
    /**
       * @description 查询列表
       */
    search () {
      // 当点击查询时，显示第一页
      this.search_form.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.getList()
    },
    /**
       * @description 获取列表数据
       */
    getList () {
      this.loading = true
      let data = this.formatSearch(this.search_form)
      data = qs.stringify(data)
      agentChannelList(data).then((data) => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.loading = false
          this.list = []
        } else {
          this.loading = false
          this.paginations.total = data.data.totalCount
          this.list = data.data.list
          this.search_form.count = data.data.totalCount
        }
      }).catch(() => {
      })
    },
    /**
       * @description 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      const totalCount = this.search_form.count
      this.search_form.pageNo = page
      this.search_form.Count = totalCount
      this.getList()
    },
    /**
       * @description 清除对象中无值属性
       */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
       * @description 增加渠道商拓展二维码
       */
    addQrCode () {
      const data = Object.assign({}, this.qrCodeForm)
      data.imgUrl = ''
      const para = qs.stringify(data)
      uploadChannelQrCode(para).then(data => {
        this.addLoading = false
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
          this.resetForm()
          this.qrCodeVisible = false
          this.getList()
        } else {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        }
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
  .list{
    margin-left: 16px;
  }
  .pagination{
    margin: 20px 0;
    text-align: center;
  }
</style>
